// Dependencias
import axios, { AxiosError } from 'axios';

// Utils
import { httpTokenInterceptor } from '../utils/httpTokenInterceptor';

// KEYS y Confgiuraciones
import { URL_API } from '../config/keys.config';
import { ResponseHttpCreate } from './kiuber.service';
const token = document.querySelector<HTMLInputElement>('#access-token')!.value;

// Instancia de cliente de Axios
const axiosClient = axios.create({
  baseURL: URL_API,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`
  }
});

axiosClient.interceptors.response.use((res) => res, httpTokenInterceptor);

/**
 *
 * @param options
 * @returns
 */
export async function searchClientsBy({
  params,
  limit,
  page,
  exporting
}: SearchOptions) {
  if (exporting) {
    const { data: file } = await axios.get('/users/download', {
      responseType: 'blob',
      params: {
        limit,
        page,
        ...params
      }
    });

    return file;
  }

  const { data: { users } } = await axiosClient.get<HttpResponse<Client>>('/users', {
    params: {
      ...params,
      page,
      limit
    }
  });

  return users;
}

/**
 *
 * @param param0
 * @returns
 */
export async function searchCheckClientBy({
  params,
  limit,
  page
}: SearchOptions) {
  const {
    data: { users }
  } = await axiosClient.get<HttpResponse<CheckClient>>('/users/check', {
    params: {
      ...params,
      limit,
      page
    }
  });

  return users;
}

/**
 *
 * @param param0
 * @returns
 */
export async function changeStatusUser({
  type,
  params
}: StatusOptions<GenericParams & { id: string }>) {
  const url = `/users/${params?.id}/${type}`;

  const { status } = await axiosClient.patch(url);

  return status;
}

/**
 *
 * @param param0
 */
export async function changeVeryRejectStatus({
  type,
  params
}: StatusOptions<VerifyOptios>) {
  const url =
    type === ActionTypesStatus.VERIFY
      ? '/users/check'
      : `/users/${params!.id}/reject`;

  const { status } = await axiosClient.patch(url, params);

  return status;
}

/**
 *
 * @param param0
 * @returns
 */
export async function updateUser({ params }: StatusOptions<GenericParams>) {
  const { status } = await axiosClient.patch(`/users/${params!.id}/update`, {
    ...params
  });

  return status;
}

/**
 *
 * @param param0
 * @returns
 */
export async function getOrderByClient({
  params
}: StatusOptions<OrderParamsOptions>) {
  const { data } = await axiosClient.get<OrdersResponce>(
    `/panel/orders/${params!.id}?numOrder=${params!.numOrder}`
  );

  return data;
}

/**
 *
 * @param param0
 * @returns
 */
export async function asingFolios({
  params
}: StatusOptions<AssignFoliosOptions>) {
  try {
    const { status, data } = await axiosClient.post('/assign-folios', {
      ...params
    });

    return { status, data };
  } catch (error) {
    if (error instanceof AxiosError) {
      const { status, data } = error.response!;

      return { status, data };
    }

    // Configuracion de error
    console.error(error);
  }
}

/**
 * 
 * @param client 
 * @returns 
 */
export async function createClient(client: CreateClient) {
  const { data: { data } } = await axiosClient.post<ResponseHttpCreate<{ userId: number }>>('/auth/register', client);
  return data;
}

/**
 * Activa o desactiva el campo API de un usuario
 * @param userId ID del usuario
 * @param enabled true para activar, false para desactivar
 * @returns 
 */
export async function toggleUserApi(userId: number, enabled: boolean) {
  const { status, data } = await axiosClient.patch(`/users/${userId}/api`, {
    api: enabled ? 1 : 0
  });
  return { status, data };
}

/**
 * Verifica el estado de una factura
 * @param invoiceId ID de la factura
 * @returns 
 */
export async function checkInvoiceStatus(invoiceId: string) {
  try {
    const { data } = await axiosClient.get<{ 
      message: string; 
      exists: boolean; 
      status?: string; 
      isPaid?: boolean 
    }>(`/invoices/${invoiceId}/status`);
    return data;
  } catch (error) {
    if (error instanceof AxiosError && error.response?.status === 404) {
      return { exists: false, message: 'Factura no encontrada' };
    }
    console.error(error);
    return { exists: false, message: 'Error al verificar factura' };
  }
}

// Definicion de tipos e interfaces
export type HttpResponseCreate<T> = {
  status: number;
  respose: boolean;
  message: string;
  client?: T;
}
type GenericParams = {
  [key: string]: string | number;
};
type SearchOptions = {
  params?: GenericParams;
  limit?: number;
  page?: number;
  exporting?: boolean;
};
export type AssignFoliosOptions = {
  userId: string;
  folios: string;
  amount: string;
  invoiceId: string;
  planLabel?: string;
};
type OrderParamsOptions = {
  id: string;
  numOrder: string;
};
type StatusOptions<T = undefined> = SearchOptions & {
  params?: T;
  type?: ActionTypesStatus;
};
type HttpResponse<T> = {
  users: T[];
  total: number;
  totalPages: number;
  currentPage: number;
};
type VerifyOptios = {
  id: string;
  verificado?: string | boolean;
  reason?: string;
};
export type Client = {
  id: number;
  fullName: string;
  folios: string;
  email: string;
  phone: string;
  plan: Plans;
  status: StatusUsers;
  whmcsOrderId: number;
  lastPurchaseDate: string;
  hasUploadedDocuments: boolean;
  hasSignedDocuments: boolean;
  hasSignedAsGuest: boolean;
  api: boolean;
  blocked: boolean;
};
export type CheckClient = {
  id: number;
  name: string;
  lastname: string;
  email: string;
  phone: string | null;
  status: StatusUsers;
  verificadoPor: string | null;
  rechazadoPor: string | null;
  rejectionReason: string | null;
  INE_URL: string | null;
  IMAGE_URL: string | null;
  INE_back_URL: string | null;
};
export type ClientUpdate = {
  id: string;
  name: string;
  lastname: string;
  email: string;
};
export interface LineItem {
  type: string;
  relid: number;
  producttype: string;
  product: string;
  domain?: string;
  billingcycle: string;
  amount: string;
  status: string;
}
export interface Order {
  id: number;
  ordernum: number;
  userid: number;
  contactid: number;
  date: string;
  amount: string;
  paymentmethod: string;
  invoiceid: number;
  status: string;
  lineitems: {
    lineitem: LineItem[];
  };
}
export type CreateClient = {
  name: string;
  last_name: string;
  email: string;
  password: string;
  lang: string;
  phone: string;
  countryCallingCode: string;
  equipo: string;
  country: string;
  clientIdWHMCS: number;
};

export type OrdersResponce = {
  message: string;
  orders: Order[];
};
export enum Plans {
  LITE = 'lite',
  ADVANCE = 'advance',
}
export enum StatusUsers {
  VERIFICADO = 'verified',
  SIN_VERIFICAR = 'rejected',
  PENDIENTE = 'pending',
}
export enum ActionTypesStatus {
  BLOCK = 'block',
  UNBLOCK = 'unblock',
  VERIFY = 'verify',
  REJECT = 'reject',
}
